import { createAuthAxios } from './auth';

const validationService = {
  /**
   * Validates QuePasa user exists and has correct permissions
   * @param {number} accountId - Account ID
   * @param {number} inboxId - Inbox ID
   * @returns {Promise<{valid: boolean, user: Object, error?: string}>} User validation status
   * @example
   * const result = await quepasa.service.validation.user(1, 803);
   * if (!result.valid) console.error('User not configured');
   */
  async user(accountId, inboxId) {
    const http = createAuthAxios();
    const response = await http.get(
      `/api/v1/accounts/${accountId}/quepasa/validations/user`,
      { params: { inbox_id: inboxId } }
    );
    return response.data;
  },

  /**
   * Creates or fixes QuePasa user with administrator role
   * @param {number} accountId - Account ID
   * @param {number} inboxId - Inbox ID
   * @returns {Promise<{success: boolean, user: Object}>} Fix operation result
   * @example
   * await quepasa.service.validation.fixUser(1, 803);
   */
  async fixUser(accountId, inboxId) {
    const http = createAuthAxios();
    const response = await http.post(
      `/api/v1/accounts/${accountId}/quepasa/validations/user/fix`,
      { inbox_id: inboxId }
    );
    return response.data;
  }
};

// Add help properties to each method
validationService.user.help = 'user(accountId, inboxId) - Validates QuePasa user exists and has permissions. Returns: {valid, user, error?}';
validationService.fixUser.help = 'fixUser(accountId, inboxId) - Creates or repairs QuePasa user with admin role. Returns: {success, user}';

export default validationService;
